export const WS_SERVER_URL = process.env.REACT_APP_WS_SERVER_URL ?? "https://leweso-backend.onrender.com";

export const ELASTIC_SEARCH_URL = process.env.ELASTIC_SEARCH_URL ?? "https://elastic-cloud-733w.onrender.com";
